export const NOT_FOUND_IMAGE =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20240509-e4f4b-92c32';

export const BROWSING_HISTORY_COOKIE = 'browsingHistory';
export const STATUS_SUCCESS = 'success';
export const STATUS_ERROR = 'error';

export const NO_EQUIPMENT_IMAGE = {
  src: 'https://caterpillar.scene7.com/is/image/Caterpillar/CM20250107-dc586-98c49',
  alt: 'No Equipment'
};
export const NO_SERVICE_INSIGHTS_IMG =
  'https://caterpillar.scene7.com/is/image/Caterpillar/CM20241115-93833-7095b';

export const NEW_STATE = 'new';

export const PRODUCT_LIST_LIMIT = 2;
export const RECENTLY_VIEWED = 'recentlyViewed';
export const HP_RECENT_VIEW_GA_LIST_NAME = 'PCC HP Recently Viewed';

const PRIMARY_GA_EVENT_CTA = 'e_primaryCTA';

export const ADDTOCART_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'Add to cart recently viewed section',
  BUTTON_EVENT_NAME: 'Add to Cart'
};
export const CONTACTDELEAR_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'Contact Dealer recently viewed section',
  BUTTON_EVENT_NAME: 'Contact Dealer'
};
export const REQUESTINFO_GAEVENTS = {
  PRIMARY_CTA: PRIMARY_GA_EVENT_CTA,
  CONTEXT: 'request information recently viewed section',
  BUTTON_EVENT_NAME: 'Request Information'
};
